module.exports = __webpack_public_path__ + "img/30.65095790.png";